import { POPUP_KEY_CREATE_INGREDIENT } from "../constant";
import { productsService } from "./productsService";
import { productsStorage } from "./productsStorage";
import { recipesStorageInstance as recipesStorage } from "./recipesStorage";
import {RECIPE_FILTER_GROUP_INGREDIENT} from "./recipesUtil";
import i18n from "../i18nService";

const transformProductsList = (products, i18nInstance = i18n) => {
    return products.map(it => {
        return {
            itemId: it.id,
            itemTitle: productsService.getLocalization(i18nInstance.resolvedLanguage, it.productCode, true, i18nInstance),
            included: true,
            code: it.productCode,
        };
    });
};

const createIngredientString = (ingredientsList) => {
    const result = [];
    ingredientsList.forEach(it => result.push(it.itemId));
    return result.join(',');
};

export const recipeIngredientService = {
    observersList: [],
    selectedProducts: [],
    filter: '',
    searchParams: null,
    setSearchParams: null,
    notifyItemsChangingObservers() {
        this.observersList.forEach(observer => observer());
    },
    getPossibleItems() {
        return transformProductsList(productsStorage.getItems(true))
            .filter(it => it.itemTitle.toLowerCase().includes(this.filter.toLowerCase()));
    },
    getCurrentItems() {
        return this.selectedProducts;
    },
    getPlaceHolder() {
        return "";
    },
    deleteItem(productId, deleteAll) {
        if(deleteAll) {
            this.selectedProducts = [];
            return;
        }
        this.selectedProducts = this.selectedProducts.filter(it => it.itemId !== productId);
        recipesStorage.setSelectedFilterValue(RECIPE_FILTER_GROUP_INGREDIENT, createIngredientString(this.selectedProducts));
        this.notifyItemsChangingObservers();
    },
    addItem(productId, i18nInstance = i18n) {
        if(productId !== 'null') {
            const currentProduct = productsStorage.getById(productId);
            this.selectedProducts.push({itemId: currentProduct.id, 
                itemTitle: productsService.getLocalization(i18nInstance.resolvedLanguage, currentProduct.productCode, true, i18nInstance),
                included: true});
            recipesStorage.setSelectedFilterValue(RECIPE_FILTER_GROUP_INGREDIENT, createIngredientString(this.selectedProducts));
            this.notifyItemsChangingObservers();
        }
    },
    loadItems(searchParams, i18nInstance = i18n) {
        if(searchParams && searchParams.get(RECIPE_FILTER_GROUP_INGREDIENT)) {
            for(let productId of searchParams.get(RECIPE_FILTER_GROUP_INGREDIENT).split(',')) {
                !this.selectedProducts.find(it => it.itemId === productId) &&
                    this.selectedProducts.push({itemId: productId, 
                        itemTitle: productsService.getLocalization(i18nInstance.resolvedLanguage, productsStorage.getById(productId).productCode, true, i18nInstance),
                        included: true});
            }
            this.notifyItemsChangingObservers();
        }
    },
    registerItemsChangingObserver(observer) {
        this.observersList.push(observer);
    },
    unRegisterItemsChangingObserver(observer) {
        try {
            this.observersList = this.observersList.filter(observerItem => observerItem !== observer);
        } catch (err) {
            console.log(err);
        }
    },
    hasExcludedItemsBlock() {
        return false;
    },
    setSearchFilterValue(searchValue) {
        this.filter = searchValue;
        this.notifyItemsChangingObservers();
    },
    getSearchString() {
        return this.filter;
    },
    isSearchStringChanged() {
        return true;
    },
    handleSearchFilterValue() {},
    getPopupKey() {
        return POPUP_KEY_CREATE_INGREDIENT;
    },
    getButtonTitle(i18nInstance = i18n) {
        return i18nInstance.t('app.page.recipe.addProduct');
    },
    getIngredientType() {
        return this.ingredientType;
    },
    changeIngredientType() {
        return;
    },
    getLabelValue(i18nInstance = i18n) {
        return i18nInstance.t('app.page.product.filters.ingredient');
    },
    createSearchParams(searchParams, setSearchParams) {
        this.searchParams = searchParams;
        this.setSearchParams = setSearchParams;
    },
};
